import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/LoginConstant';
import restClient from '../../MainFrame/action/APIClient';

var LoginAction = function () {

}

LoginAction.prototype = {
	login: function (userObject) {
		restClient.login(userObject, function (error, response) {
			if (error) {
				AppDispatcher.dispatch({
					actionType: Constant.SIGN_IN_ERROR,
					data: error
				});
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.SIGN_IN_RESPONSE_RECIEVED,
					data: response
				});
			}
		});
	}
}

export default new LoginAction();